export const welcomeScreenStyles = {
  root: "flex flex-1 flex-col items-center justify-center px-5 pb-6 pt-2",
  avatar: "mb-3 h-11 w-11",
  greeting: "text-center text-base font-semibold leading-snug text-strong",
  subtitle: "mt-1 text-center text-sm text-muted-foreground",
  cardList: "mt-5 flex w-full flex-col gap-2",
  card: "gap-3 rounded-xl border-muted bg-white px-3.5 py-3 shadow-sm",
  cardBtn:
    "group w-full text-left transition-all hover:border-ring-border hover:bg-accent/30 hover:shadow-md",
  cardIcon: "flex h-5 w-5 shrink-0 items-center justify-center",
  cardContent: "min-w-0 gap-0",
  cardTitle: "text-sm font-semibold leading-snug text-foreground",
  cardDesc: "mt-0.5 text-xs leading-snug text-subtle",
  cardChevron: "h-4 w-4 shrink-0 text-dim transition-colors group-hover:text-info",
  skeletonCard:
    "flex items-center gap-3 rounded-xl border border-muted bg-white px-3.5 py-3 shadow-sm",
  skeletonIcon: "h-5 w-5 shrink-0 animate-pulse rounded-full bg-accent",
  skeletonLines: "flex min-w-0 flex-1 flex-col gap-1.5",
  skeletonTitle: "h-3 w-1/3 animate-pulse rounded bg-accent",
  skeletonDesc: "h-2.5 w-2/3 animate-pulse rounded bg-accent/60",
};
